import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TextField,
  Typography,
  TablePagination,
  IconButton,
  Grid,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  useMediaQuery,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import db from '../../../services/db';
import AutocompleteWithClear from '../../../components/AutocompleteWithClear';
import MaskedDecimalInput from '../../../components/MaskInputMatriz';
import DeleteIcon from '@mui/icons-material/Delete';
import { useAuth } from '../../../contexts/AuthContext';
import { useNotification } from '../../../contexts/NotificationContext';
const Itens = ({ data, onParcelasChange, ramoAtividade, onDataChange }) => {
  const { user } = useAuth();
  const theme = useTheme();
  const { showNotification } = useNotification();
  // Variável para detectar dispositivos touch (Android, tablet etc.)
  const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

  const [itens, setItens] = useState(data);
  const [produtos, setProdutos] = useState([]);
  const [quantidade, setQuantidade] = useState(1);
  const [produtoSelecionado, setProdutoSelecionado] = useState(null);

  // Paginação
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  // Diálogo para exclusão
  const [openDialog, setOpenDialog] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);

  useEffect(() => {
    setItens(data);
  }, [data]);

  const calcularTotalPedido = () => {
    return itens.reduce((acc, item) => acc + item.total, 0);
  };
  
  // UseEffect que recalcula o total do pedido sempre que os itens mudarem
  useEffect(() => {
    const totalPedido = calcularTotalPedido();
    if (onParcelasChange) {
      onParcelasChange(totalPedido);
    }
  }, [itens]);

  
  // Busca produtos e preços do banco de dados
  useEffect(() => {
    const fetchProdutos = async () => {
      try {
        const todosProdutos = await db.produtos.toArray();
        const todosPrecos = await db.precos.toArray();

        const produtosComPrecos = todosProdutos.map((produto) => {
          const preco = todosPrecos.find(
            (p) =>
              p.idProdutoPrecificacao &&
              produto.idProdutoPrecificacao &&
              p.idProdutoPrecificacao === produto.idProdutoPrecificacao
          );
          return {
            ...produto,
            precoVarejo: preco?.precoVistaVarejo || 0,
            precoAtacado: preco?.precoVistaAtacado || 0,
          };
        });

        setProdutos(produtosComPrecos);
      } catch (error) {
        console.error('Erro ao carregar produtos:', error);
      }
    };

    fetchProdutos();
  }, []);

  const handleAddItem = () => {
    console.log('1sk')
    if (!produtoSelecionado) {
      alert('Selecione um produto para adicionar.');
      return;
    }

    const preco =
      ramoAtividade === 'varejo' || ramoAtividade === 'outros'
        ? produtoSelecionado.precoVarejo
        : produtoSelecionado.precoAtacado;

    const itemExistenteIndex = itens.findIndex(
      (item) => item.codigoProduto === produtoSelecionado.codigoProduto
    );

    const novosItens = [...itens];

    if (itemExistenteIndex > -1) {
      const itemExistente = novosItens[itemExistenteIndex];
      const novaQuantidade = itemExistente.quantidade + quantidade;

     /* if (novaQuantidade > produtoSelecionado.quantidadeDisponivel) {

        showNotification(`Saldo disponível insuficiente: ${produtoSelecionado.quantidadeDisponivel}`, 'warning');
        return;
      }*/

      novosItens[itemExistenteIndex] = {
        ...itemExistente,
        quantidade: novaQuantidade,
        total: novaQuantidade * preco,
      };
    } else {
     /* if (quantidade > produtoSelecionado.quantidadeDisponivel) {
        showNotification(`Saldo disponível insuficiente: ${produtoSelecionado.quantidadeDisponivel}`, 'warning');
        return;
      }*/

      const novoItem = {
        ...produtoSelecionado,
        quantidade,
        preco,
        total: preco * quantidade,
      };

      novosItens.push(novoItem);
    }

    setItens(novosItens);
    if (onDataChange) onDataChange(novosItens);
    setQuantidade(1);
    setProdutoSelecionado(null);
  };

  const handleQuantidadeChange = (itemId, novaQuantidade) => {
    setItens((prevItens) => {
      const novosItens = [...prevItens];
      const itemExistenteIndex = novosItens.findIndex(
        (item) => item.codigoProduto === itemId
      );

      if (itemExistenteIndex === -1) return prevItens;

      const itemExistente = novosItens[itemExistenteIndex];

      novosItens[itemExistenteIndex] = {
        ...itemExistente,
        quantidade: novaQuantidade,
        total: novaQuantidade * itemExistente.preco,
      };

      if (onDataChange) onDataChange(novosItens);
      return novosItens;
    });
  };

  const handlePageChange = (event, newPage) => setPage(newPage);
  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const formatarValor = (valor) => {
    const casasDecimais = user?.matriz?.casasDecimaisValorUnitario ?? 2;
    const numero = Number(valor);
    if (isNaN(numero)) return '0,00';
    return numero.toFixed(casasDecimais).replace('.', ',');
  };

  const handleDeleteItem = (item) => {
    setItemToDelete(item);
    setOpenDialog(true);
  };

  const confirmDeleteItem = () => {
    const novosItens = itens.filter(
      (item) => item.codigoProduto !== itemToDelete.codigoProduto
    );
    setItens(novosItens);
    if (onDataChange) onDataChange(novosItens);
    setOpenDialog(false);
    setItemToDelete(null);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setItemToDelete(null);
  };

  const precoSelecionado =
    ramoAtividade === 'varejo' || ramoAtividade === 'outros'
      ? produtoSelecionado?.precoVarejo ?? 0
      : produtoSelecionado?.precoAtacado ?? 0;

  const valorTotal = quantidade * precoSelecionado;



  return (
    <Box
      sx={{
        padding: isTouchDevice ? 3 : 2,
        margin: isTouchDevice ? 2 : 0,
      }}
    >
      <Grid container spacing={isTouchDevice ? 2 : 1}>
        {/* Campo de busca ocupando a linha toda */}
        <Grid item xs={12}>
          <AutocompleteWithClear
            label="Buscar Produto"
            options={produtos}
            multiline={true}
  rows={4}
            value={produtoSelecionado}
            displayField="descricao"
            getOptionLabel={(option) =>
              `${option.codigoProduto} - ${option.descricao} - Vlr R$: ${ramoAtividade === 'varejo' || ramoAtividade === 'outros'
                ? option.precoVarejo.toFixed(2)
                : option.precoAtacado.toFixed(2)
              } - QTD Disp.: ${option.quantidadeDisponivel || 'N/A'}`
            }
            onChange={(value) => setProdutoSelecionado(value)}
            onSelect={(value) => setProdutoSelecionado(value)}
            onClear={() => setProdutoSelecionado(null)}
            fullWidth
          />
        </Grid>

        {/* QTD e Botão "Adicionar" na linha de baixo */}
        <Grid item xs={4}>
        <MaskedDecimalInput
                      label="Qtd"
                      value={quantidade}
                      onChange={(novaQuantidade) =>
                        setQuantidade(novaQuantidade)
                      }
                      fullWidth
                    />
        </Grid>
        <Grid item xs={5}>
          <MaskedDecimalInput
            label="Valor total"
            disabled
            // Utilize a mesma formatação que já está usando na função formatarValor, se quiser manter o padrão:
            value={valorTotal}
            fullWidth
          />
        </Grid>
        <Grid item xs={6}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleAddItem}
            fullWidth={isTouchDevice}
            size={isTouchDevice ? 'large' : 'medium'}
          >
            Adicionar
          </Button>
        </Grid>
      </Grid>


      <Typography variant="h6" sx={{ marginTop: 4, marginBottom: 2 }}>
        Itens
      </Typography>

      <Box sx={{ overflowX: 'auto' }}>
        <Table size={isTouchDevice ? 'medium' : 'small'}>
          <TableHead>
            <TableRow>
              <TableCell>Quantidade</TableCell>
              <TableCell>Código</TableCell>
              <TableCell>Descrição</TableCell>
              <TableCell>Unitário</TableCell>
              <TableCell>Total</TableCell>
              <TableCell>Ações</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {itens
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((item, index) => (
                <TableRow key={index}>
                  <TableCell sx={{ minWidth: 80 }}>
                    <MaskedDecimalInput
                      label="Qtd"
                      value={item.quantidade}
                      onChange={(novaQuantidade) =>
                        handleQuantidadeChange(item.codigoProduto, novaQuantidade)
                      }
                      fullWidth
                    />
                  </TableCell>
                  <TableCell>{item.codigoProduto}</TableCell>
                  <TableCell>{item.descricao}</TableCell>
                  <TableCell>{formatarValor(item.preco)}</TableCell>
                  <TableCell>{formatarValor(item.total)}</TableCell>
                  <TableCell>
                    <IconButton onClick={() => handleDeleteItem(item)}>
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </Box>

      <TablePagination
        component="div"
        count={itens.length}
        page={page}
        rowsPerPage={rowsPerPage}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleRowsPerPageChange}
      />

      {/* Diálogo de confirmação para exclusão */}
      <Dialog open={openDialog} onClose={handleCloseDialog}>
        <DialogTitle>Confirmar Exclusão</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Tem certeza que deseja excluir o item {itemToDelete?.descricao}?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary">
            Cancelar
          </Button>
          <Button onClick={confirmDeleteItem} color="primary">
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Itens;
